import { environment } from 'src/environments/environment';

export const LOYALTY_PROGRAM_APIS_ENDPOINTS = {
  GET_LOYALTY_TIERS: `${environment.BACKEND_URL}api/engagement/loyalty-tiers`,
  GET_MERCHANT_LOYALTY_PROGRESS: `${environment.BACKEND_URL}api/engagement/merchant-loyalty-tier`,
};
